export default __webpack_public_path__ + "static/media/phone-yellow.0eb0105f.svg";